import axios from 'axios'
import API from '@/common/api'
import store from '..'

export default {
  namespaced: true,
  state: {
    indexedDbStorage: null
  },
  mutations: {
  },
  actions: {
    async getLastVersion ({ state }, data) {
        /**
         * page 또는 product의 최신 버전 호출
         * 버전이 없는 경우(legacy files) return last_version: 0
         */
        try {
          const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-version-file&method=get&func=last-version&siteid=${API.SITE_INFO.site}&file=${data.file}`)
          return res.data.message && res.data.message.last_version
        } catch (ex) {
          return ex && ex.response && ex.response.data
        }
    },
    async getFile ({ state }, data) {
      /**
       * 버전별 파일 불러오기
       * 없는 경우 가장 최신 버전 호출
       */
      try {
        const version = data.version ? `&version=${data.version}` : ''
        const res = await axios.get(`${API.BASE_URL}/castit/file?cmd=get-version-file&method=get&func=gvf&siteid=${API.SITE_INFO.site}&file=${data.file}${version}`)
        return {
            ...res.data.message,
            data: {
                id: data.fileId, // gvf json 데이터에 id가 없는 경우가 있어 추가로 assign
                version: res.data.message.last_version,
                ...res.data.message.data
            }
        }
      } catch (ex) {
        return ex && ex.response && ex.response.data
      }
    },
    async getIndexedDb ({ state }, data) {
      /**
       * indexedDb에서 db 생성 및 기 저장된 gvf 데이터 호출
       * 요청한 파일의 버전과 indexedDb 데이터의 버전이 맞는 경우
       * 해당 버전의 파일 데이터 리턴
       * 버전이 맞지 않는 경우
       * 'diffVersion' 리턴 -> 컴포넌트에서 getFile
       */
        const site = store.state.authentication.site
        const idxedDB = window.indexedDB
        if (idxedDB) {
            return new Promise ((resolve, reject) => {
                const request = idxedDB.open(`${site}_store`)
                request.onerror = (e) => {
                    reject(e)
                }
                // db가 새로 생성되면 테이블 및 인덱스 생성
                request.onupgradeneeded = (e) => {
                    const db = e.target.result
                    const objectStore = db.createObjectStore('gvf', { keyPath: 'id' })
                    objectStore.createIndex('id', 'id', { unique: true })
                    objectStore.createIndex('content_type', 'content_type', { unique: false })
                    objectStore.createIndex('version', 'version', { unique: false })
                    objectStore.createIndex('data', 'data', { unique: false })
                    objectStore.createIndex('updateat', 'updateat', { unique: false })
                }
                // gvf 테이블에서 요청한 데이터 리턴
                request.onsuccess = (e) => {
                    const db = request.result
                    const transaction = db.transaction('gvf')
                    transaction.onerror = (e) => reject(e)
                    const objStore = transaction.objectStore('gvf')
                    const objStoreRequest = objStore.get(data.id)
                    objStoreRequest.onsuccess = (e) => {
                      resolve(objStoreRequest.result && objStoreRequest.result.version === data.version ? objStoreRequest.result.data : 'diffVersion')
                    }
                }
            })
        }
    },
    async setIndexedDb ({ state, dispatch }, data) {
      /**
       * api 호출된 파일 데이터를 indexedDb에 저장
       * 파일 id를 key로 사용하여 해당 데이터를 버전과 함께 저장
       */
        const site = store.state.authentication.site
        const idxedDB = window.indexedDB
        if (idxedDB) {
            let db
            const request = idxedDB.open(`${site}_store`)
            request.onerror = (e) => console.log(e)
            request.onsuccess = (e) => {
                // (생성 또는 업데이트)저장될 때마다 용량 체크
                dispatch('checkIndexedDbStorage')
                db = request.result
                const transaction = db.transaction('gvf', 'readwrite')
                const objStore = transaction.objectStore('gvf')
                const objStoreRequest = objStore.get(data.id)
                objStoreRequest.onsuccess = (e) => {
                  const isExist = objStoreRequest.result && objStoreRequest.result.version !== data.version
                  const method = isExist ? 'put' : 'add'
                  // 데이터 추가 또는 수정
                  objStore[method]({
                    id: data.id,
                    content_type: data.table,
                    version: data.version,
                    data: data.data,
                    updateat: new Date().toISOString()
                  })
                  // console.log(isExist ? '⇔ put data' : '≫ add data')
                }
            }
        }
    },
    async deleteIndexedDb ({ state, dispatch }, id) {
      /**
       * api 호출된 파일 데이터를 indexedDb에 저장
       * 파일 id를 key로 사용하여 해당 데이터를 버전과 함께 저장
       */
        const site = store.state.authentication.site
        const idxedDB = window.indexedDB
        if (idxedDB) {
          return new Promise ((resolve, reject) => {
            let db
            const request = idxedDB.open(`${site}_store`)
            request.onerror = (e) => console.log(e)
            request.onsuccess = (e) => {
              db = request.result
              const transaction = db.transaction('gvf', 'readwrite')
              const objStore = transaction.objectStore('gvf')
              if (id && id !== 'all' && objStore) {
                const objStoreRequest = objStore.delete(id)
                objStoreRequest.onsuccess = (e) => {
                  console.log('delete data')
                  dispatch('checkIndexedDbStorage')
                  resolve(true)
                }
              } else {
                const objStoreRequest = objStore.clear()
                objStoreRequest.onsuccess = (e) => {
                  console.log('delete data all')
                  dispatch('checkIndexedDbStorage')
                  resolve(true)
                }
              }
            }
          })
        }
    },
    // indexedDb 용량 정보 체크
    async checkIndexedDbStorage ({ state }) {
      function formatBytes (bytes, decimals = 2) {
        return `${(bytes / (1024 * 1024)).toFixed(5)}mb`
      }
      if (navigator.storage && navigator.storage.estimate) {
        const quota = await navigator.storage.estimate()
        const percentageUsed = (quota.usage / quota.quota) * 100
        const remaining = quota.quota - quota.usage
        // console.log('indexedDb storage information')
        // console.log(`quota: ${formatBytes(quota.quota, 3)} | remaining: ${formatBytes(remaining, 3)} | usage - ${percentageUsed}%`)
        state.indexedDbStorage = {
          quota: quota.quota,
          usage: quota.usage,
          remaining: quota.quota - quota.usage,
          percentageUsed: ((quota.usage / quota.quota) * 100).toFixed(2)
        }
      }
      return
    }
  },
  getters: {
    getIndexedDbStorage: state => state.indexedDbStorage
  }
}
